import React from "react"
import { ButtonLoadingSeeker, IconSeeker } from "@ui-seeker/core"

import { useUserSettingsCategory } from "../../@hooks"


export default function UserSettingsCategoryTabButton() {

    const { handleSetCategoryFormData } = useUserSettingsCategory()

    return <ButtonLoadingSeeker
        startIcon={<IconSeeker icon="add" />}
        onClick={handleSetCategoryFormData}
    >
        Define Category Color
    </ButtonLoadingSeeker>
}